import { SimulabStage, useSimulabContext } from "@/entities/simulab"

import "../styles.scss"

import { StageName } from "./StageName"

export const SimulabFirstMesageStage = () => {
    const { simulabMessages, conversation } = useSimulabContext()

    const firstStage: SimulabStage = conversation?.stages?.[0]

    return (
        simulabMessages?.messages?.length === 0 && (
            <div className="mb-[30px]">
                <StageName
                    disabled
                    phase={firstStage?.phase}
                    name={firstStage?.title}
                    isCurrentStage
                    isFirstStage
                    completed={false}
                />
            </div>
        )
    )
}
